<i18n src='@/locale/diagnosis-form-component-localization.json'></i18n>

<template>
    <v-container v-if="historyCode && historyCode > 0">
        <v-row class="mb-4 bg-red d-flex justify-space-between align-center">
            <div>
                <v-btn color="success" class="mr-4" @click="addOrEdit">
                {{ number && number > 0 ? $t("Save") : $t("Add") }}
                </v-btn>
                <v-btn color="error" @click="$emit('Cancel')"> {{ $t("Cancel") }} </v-btn>
            </div>
            <slot name="headerCenter"></slot>
            <div class="text-h6"> {{ formTitle }}</div>
        </v-row>
        <v-row>
            <date-picker-menu
                v-model="models.DateTimeFrom"
                :label="$t('Start')"
                clearable
            ></date-picker-menu>
            <v-btn icon @click="copyPasteDate">
                <v-icon>mdi-arrow-right-bold</v-icon>
            </v-btn>
            <date-picker-menu
                v-model="models.DateTimeTill"
                :label="$t('End')"
                clearable
            ></date-picker-menu>
            <v-select
                :items="options"
                :label="$t('Option')"
                v-model="models.Option"
                outlined
                dense
                class="mx-4 mini-width"
            ></v-select>
            <v-select
                :items="payers"
                :label="$t('Payer')"
                v-model="models.Payer"
                outlined
                dense
                class="mini-width"
            ></v-select>
        </v-row>
        <v-row class="my-4">
            <nosology-select 
                v-model="models.NosologyCode"
                :label="$t('Diagnosis')"
                class="middle-width"
                v-if="fieldsControl.NosologyCode.visible"
                :readonly="fieldsControl.NosologyCode.disabled"
            ></nosology-select>
            <v-text-field 
                class="mini-width-2 ml-4"
                :label="$t('Amount')"
                v-model="models.Amount"
                outlined 
                dense
                v-if="fieldsControl.Amount.visible"
                :disabled="fieldsControl.Amount.disabled"
            ></v-text-field>
        </v-row>
        <v-row class="my-4">
            <department-select 
                v-model="models.DepartmentCode" 
                class="middle-width"
            ></department-select>
        </v-row>
        <v-row class="mb-3">
            <person-select 
                v-model="models.DoctorCode"
                :label="$t('Doctor')"
                class="middle-width"
                v-if="fieldsControl.DoctorCode.visible"
                :readonly="fieldsControl.DoctorCode.disabled"
            ></person-select>
        </v-row>
        <v-row class="my-4">
            <person-select 
                v-model="models.NurseCode"
                :label="$t('Nurse')"
                class="middle-width"
            ></person-select>
        </v-row>
        <v-row>
            <person-select 
                v-model="models.OtherCode"
                :label="$t('Other')"
                class="middle-width"
            ></person-select>
        </v-row>
        <v-row class="my-6">
            <v-select
                :items="solutionList"
                v-model="models.Out"
                :label="$t('Soluction')"
                outlined
                dense
                class="middle-width"
            ></v-select>
        </v-row>
        <v-row>
            <v-radio-group v-model="models.DZIR">
                <v-radio
                    v-for="(item, i) in dzir"
                    :label="item.text"
                    :value="item.value"
                    :key="i"
                ></v-radio>
            </v-radio-group>
            <v-radio-group v-model="models.PlanType" class="mx-6">
                <v-radio
                    v-for="(item, i) in planTypes"
                    :label="item.text"
                    :value="item.value"
                    :key="i"
                ></v-radio>
            </v-radio-group>
            <v-radio-group
                v-model="models.HepatitisC"
                :label="$t('HepatitisC')"
                class="mx-6"
            >
                <v-radio
                    v-for="(item, i) in HepatitisC"
                    :label="item.text"
                    :value="item.value"
                    :key="i"
                ></v-radio>
            </v-radio-group>
            <v-col>
                <v-checkbox
                    v-for="(item, i) in chekBoxes"
                    :label="item.text"
                    :value="item.value"
                    v-model="models.SelectedChekBoxes"
                    :key="i"
                    hide-details
                    class="mt-2"
                ></v-checkbox>
            </v-col>
        </v-row>
        <v-row class="d-flex">
            <v-text-field
                :label="$t('StandardPrice')"
                v-model="models.StandardPrice"
                outlined
                dense
            ></v-text-field>
            <v-select
                :items="pricePercents"
                :label="$t('PricePercent')"
                v-model="models.PricePercent"
                outlined
                dense
                class="mx-4"
            ></v-select>
            <v-text-field 
                :label="$t('Price')"
                outlined 
                dense
                v-model="models.Price"
            ></v-text-field>
        </v-row>
        <v-row>
            <v-select
                :items="statuses"
                v-model="models.Status"
                :label="$t('Status')"
                outlined
                dense
                class="middle-width"
            ></v-select>
        </v-row>
        <v-row class="d-flex">
            <v-text-field 
                v-model="models.Year"
                :label="$t('YearOfRequest')"
                outlined 
                dense
            ></v-text-field>
            <v-text-field
                v-model="models.SalaryYear"
                :label="$t('SalaryYear')"
                outlined
                dense
                class="mx-4"
            ></v-text-field>
            <v-select
                :items="salaryMonths"
                v-model="models.SalaryMonth"
                :label="$t('SalaryMonths')"
                outlined
                dense
            ></v-select>
        </v-row>
        <v-row>
            <v-text-field
                v-model="models.ProvisionalDiagnosis"
                :label="$t('ProvisionalDiagnosis')"
                outlined
                dense
                class="middle-width"
            ></v-text-field>
            <v-text-field
                v-model="models.Base"
                :label="$t('Branch')"
                outlined
                dense
                class="middle-width ml-4"
            ></v-text-field>
        </v-row>
        <v-row>
            <v-text-field
                v-model="models.Kat"
                :label="$t('KAT')"
                outlined
                dense
                class="middle-width"
            ></v-text-field>
            <v-text-field
                v-model="models.Number"
                label="#"
                outlined
                dense
                class="middle-width ml-4"
            ></v-text-field>
        </v-row>
        <v-row>
            <v-text-field
                v-model="models.MessageCode"
                :label="$t('MessageCode')"
                outlined
                dense
                class="middle-width"
            ></v-text-field>
        </v-row>
        <v-row>
            <person-select 
                v-model="models.SenderDoctor"
                :label="$t('SenderDoctor')"
                class="middle-width"
            ></person-select>
        </v-row>
    </v-container>
</template>

<script>
import datePickerMenu from "./date-picker-menu.vue";
import personSelect from "./person-select.vue";
import nosologySelect from "./nosology-select.vue";
import departmentSelect from "./department-select.vue";
import diagnosisService from "@/service/diagnosis-service";

export default {
    components: {
        datePickerMenu,
        personSelect,
        nosologySelect,
        departmentSelect,
    },
    props: {
        historyCode: Number,
        number: Number,
        formTitle: String,
        diagnosisData: {
            type: Object
        }
    },
    data() {
        return {
            options: [1, 2, 3, 4, 5, 6, 7, 8, 9],
            payers: [1, 2, 3],
            dzir: [
                {
                    text: this.$t('Basic'),
                    value: 1,
                },
                {
                    text: this.$t('Accompanying'),
                    value: 0,
                },
                {
                    text: this.$t('Secondary'),
                    value: 2,
                },
                {
                    text: this.$t('Frustration'),
                    value: 3,
                },
            ],
            planTypes: [
                {
                    text: this.$t('Planned'),
                    value: 1,
                },
                {
                    text: this.$t('Urgent'),
                    value: 2,
                },
                {
                    text: this.$t('DayStation'),
                    value: 3,
                },
                {
                    text: this.$t('PHC'),
                    value: 4,
                },
            ],
            HepatitisC: [
                {
                    text: this.$t('Positive'),
                    value: 1,
                },
                {
                    text: this.$t('Negative'),
                    value: 2,
                },
                {
                    text: this.$t('NotConducted'),
                    value: 3,
                }
            ],
            chekBoxes: [
                {
                    text: this.$t('ViolenceResult'),
                    value: "ViolenceCheckbox",
                },
                {
                    text: this.$t('Reported'),
                    value: "ReportedCheckbox",
                },
                {
                    text: this.$t('Uploaded'),
                    value: "BCheckbox",
                },
                {
                    text: this.$t('Prohibition'),
                    value: "NotEditable",
                },
            ],
            pricePercents: [10, 25, 50],
            statuses: [
                {
                    text: "1 " + this.$t('NotStarted'),
                    value: 1,
                },
                {
                    text: "2 " + this.$t('InProgress'),
                    value: 2,
                },
                {
                    text: "3 " + this.$t('NotSubjectTo'),
                    value: 3,
                },
                {
                    text: "4 " + this.$t('Started'),
                    value: 4,
                },
                {
                    text: "5 " + this.$t('Partial'),
                    value: 5,
                },
            ],
            solutionList: [
                {
                    value: "დას",
                    text: this.$t("Das")
                },
                {
                    value: "დას2",
                    text: this.$t("Das2")
                },
                {
                    value: "დას3",
                    text: this.$t("Das3")
                },
                {
                    value: "დას4",
                    text: this.$t("Das4")
                },
                {
                    value: "დას5",
                    text: this.$t("Das5")
                },
                {
                    value: "დას6",
                    text: this.$t("Das6")
                },
                {
                    value: "ლეტ",
                    text: this.$t("Let")
                },
                {
                    value: "შეწ",
                    text: this.$t("Shew")
                },
                {
                    value: "გად1",
                    text: this.$t("Gad1")
                },
                {
                    value: "გად2",
                    text: this.$t("Gad2")
                },
                {
                    value: "გად3",
                    text: this.$t("Gad3")
                }
            ],
            salaryMonths: [
                {
                    text: this.$t('January'),
                    value: 1,
                },
                {
                    text: this.$t('February'),
                    value: 2,
                },
                {
                    text: this.$t('March'),
                    value: 3,
                },
                {
                    text: this.$t('April'),
                    value: 4,
                },
                {
                    text: this.$t('May'),
                    value: 5,
                },
                {
                    text: this.$t('June'),
                    value: 6,
                },
                {
                    text: this.$t('July'),
                    value: 7,
                },
                {
                    text: this.$t('August'),
                    value: 8,
                },
                {
                    text: this.$t('September'),
                    value: 9,
                },
                {
                    text: this.$t('October'),
                    value: 10,
                },
                {
                    text: this.$t('November'),
                    value: 11,
                },
                {
                    text: this.$t('December'),
                    value: 12,
                },
            ],
            models: {
                DateTimeFrom: new Date().toLocaleString(),
                DateTimeTill: null,
                Option: 1,
                Payer: 2,
                NosologyCode: null,
                Amount: null,
                DepartmentCode: null,
                DoctorCode: null,
                NurseCode: null,
                OtherCode: null,
                Out: null,
                DZIR: 1,
                PlanType: null,
                HepatitisC: null,
                SelectedChekBoxes: [],
                StandardPrice: null,
                PricePercent: null,
                Price: null,
                Status: null,
                Year: null,
                SalaryYear: null,
                SalaryMonth: null,
                ProvisionalDiagnosis: null,
                Base: null,
                Kat: null,
                Number: null,
                MessageCode: null,
                SenderDoctor: null
            },
            fieldsControl: {
                NosologyCode: {
                    visible: true,
                    disabled: true
                },
                Amount: {
                    visible: true,
                    disabled: true
                },
                DoctorCode: {
                    visible: true,
                    disabled: true
                }
            }
        };
    },
    methods: {
        copyPasteDate() {
            if (!this.models.DateTimeTill) {
                this.models.DateTimeTill = this.models.DateTimeFrom;
            }
        },
        addOrEdit() {
            diagnosisService.addOrEdit({
                id: this.number,
                historyCode: this.historyCode,
                ...this.models
            }).then(()=>{
                this.$emit('updated')
            })
        },
    },
    watch: {
        historyCode() {
            this.getDiagnosis();
        },
        number() {
            this.getDiagnosis();
        },
        diagnosisData: {
            handler(val){
                this.models = {...val}
            },
            deep: true
        }
    }
};
</script>

<style>
.mini-width {
    max-width: 80px;
}
.mini-width-2 {
    max-width: 180px;
}
.middle-width {
    max-width: 475px;
}
</style>
